import PropTypes from "prop-types";
import React from "react";
import { MSpinner, TextField, TextBlock } from "components/Shared";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";


const PolicyInfo = ({ isFetching, policyInfo }) => {
    if (isFetching) {
        return <MSpinner />;
    }

    const PolicyInformation = () => (
        <CardContent>
            {policyInfo.policyHolderInfo ? (
                <div>
                    <TextField field={policyInfo.policyHolderInfo.policyholderName.fullName} placeholder="Policyholder Name" styleClass="fieldText-bold" />
                    <TextField field={policyInfo.policyHolderInfo.policyNumber} placeholder="Policy Number" styleClass="" />
                    <TextField field={policyInfo.policyHolderInfo.policyholderPhoneHome} placeholder="Policyholder Phone" styleClass="" />
                </div>
            ) : (<TextField field="No Policyholder Information Available" placeholder="" styleClass="" />)}
            <br />
            <TextField field="Survey Address" placeholder="" styleClass="fieldText-bold" />
            {policyInfo.surveyAddress ? (
                <div>
                    <TextField field={policyInfo.surveyAddress.address1} placeholder="Survey Address" />
                    <TextBlock field={policyInfo.surveyAddress.city} placeholder="Survey Address City" />,
                <TextBlock field={policyInfo.surveyAddress.state} placeholder="Survey Address State" />,
                <TextBlock field={policyInfo.surveyAddress.zip} placeholder="Survey Address Zip" />
                    <TextField field={policyInfo.surveyAddress.county} placeholder="Survey Address County" />
                </div>
            ) : (<TextField field="No Survey Address Found" />)}
            <br />
            <TextField field="Mailing Address" placeholder="" styleClass="fieldText-bold" />
            {policyInfo.mailingAddress ? (
                <div>
                    <TextField field={policyInfo.mailingAddress.address1} placeholder="Mailing Address" styleClass="" />
                    <TextBlock field={policyInfo.mailingAddress.city} placeholder="Mailing Address City" styleClass="" />,
                <TextBlock field={policyInfo.mailingAddress.state} placeholder="Mailing Address State" styleClass="" />,
                <TextBlock field={policyInfo.mailingAddress.zip} placeholder="Mailing Address Zip" styleClass="" />
                </div>
            ) : (<TextField field="No Mailing Address Found" placeholder="" styleClass="" />)}
            <br />
            <TextField field="Customer Info" placeholder="" styleClass="fieldText-bold" />
            {policyInfo.customerInfo ? (
                <div>
                    <TextField field={policyInfo.customerInfo.customerName} placeholder="Customer Name" styleClass="" />
                    <TextBlock field="Customer #: " placeholder="" styleClass="" />
                    <TextBlock field={policyInfo.customerInfo.customerNumber} placeholder="Customer Number" styleClass="" />
                </div>
            ) : (<TextField field="No Customer Information Found" placeholder="" styleClass="" />)}
            <br />
            <TextField field="Agency" placeholder="" styleClass="fieldText-bold" />
            {policyInfo.agencyInfo ? (
                <div>
                    <TextField field={policyInfo.agencyInfo.agentName} placeholder="Agent Name" styleClass="" />
                    <TextField field={policyInfo.agencyInfo.agentPhone} placeholder="Agent Phone" styleClass="" />
                    <TextField field={policyInfo.agencyInfo.address} placeholder="Agent Address" styleClass="" />
                    <TextBlock field={policyInfo.agencyInfo.city} placeholder="Agent City" styleClass="" />,
                <TextBlock field={policyInfo.agencyInfo.state} placeholder="Agent State" styleClass="" />
                </div>
            ) : (<TextBlock field="No Agency Information Available" placeholder="" styleClass="fieldText-bold" />)}
        </CardContent>
    );

    return (
        <div className="details-cards">
            <Card className="md-block-centered">
                <CardContent><Typography variant="h6">Policy Information</Typography></CardContent>
                <PolicyInformation />
            </Card>
        </div>
    );
};

PolicyInfo.propTypes = {
    isFetching: PropTypes.bool.isRequired,
    policyInfo: PropTypes.object.isRequired
};

export default PolicyInfo;